module.exports = new __parcel__URL__("empty-no-boards.ff2b4767.svg").toString();